"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/DirectoryCreateNewModal/CreateNewTeam.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);




var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _session = require('shared/selectors/session');
var _noticeBar = require('web/services/context/noticeBar');
var _hooks = require('web/services/hooks');

var _Forms = require('web/screens/Directory/Forms');
var _WarningBar = require('web/components/WarningBar'); var _WarningBar2 = _interopRequireDefault(_WarningBar);






const CreateNewTeam = ({ orgKeyContext, onClose }) => {
  const orgKey = _hooks.useAppSelector.call(void 0, state => orgKeyContext || _session.selectSelectedOrgKey.call(void 0, state))
  const { showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const onSubmit = _react.useCallback.call(void 0, 
    async ({ name }) => orgKey &&
      _actions2.default.createTeam({ OrgKey: orgKey, TeamName: name })
        .then(({ Teams }) => {
          const [teamKey] = Object.keys(Teams) 
          if (!teamKey) throw new Error('No created teams found')
          return _actions2.default.gotoTeamPage(orgKey, teamKey)
        })
        .then(onClose)
        .catch(() => showWarningBar('Failed to create a team')),
    [onClose, orgKey, showWarningBar],
  )

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      ,  !orgKey && (
        _react2.default.createElement(_WarningBar2.default, {
          className: "directory--create-new--warning",
          text: "You need to join an organization before creating a team."         , __self: this, __source: {fileName: _jsxFileName, lineNumber: 38}}
        )
      )
      , _react2.default.createElement(_Forms.TeamForm, {
        submitBtnLabel: "Create",
        orgKeyContext: orgKey,
        onSubmit: onSubmit,
        onCancel: onClose,
        controlsClassName: "invite-contact--form-controls", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
      )
    )
  )
}

exports. default = _react.memo.call(void 0, CreateNewTeam)
